export default function MapLocation() {
    return (
        <>
            <section id="map-section">
                <div className="map-container">
                    <iframe
                        title="Google Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31154.963125002014!2d75.77512759915062!3d26.878146316015364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db577800ca2b1%3A0x754b7f67df7e9392!2sStrumming%20Tunes%20Music%20Academy%20And%20Events%20%3A%20Premiere%20Music%20School%20%7C%20Rajasthan's%201st%20Flamenco%20Training%20Center!5e0!3m2!1sen!2sin!4v1753508954876!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
            </section>
        </>
    );
} 